import REST from './REST';
import {
    isIOS,
} from "react-device-detect";
import NetworkSpeed from 'network-speed';
import {API_URL} from "./Consts";


export default class Helpers {

    static async getNetworkUploadSpeed() {
        const testNetworkSpeed = new NetworkSpeed();
        const url = new URL(API_URL);
        const options = {
            hostname: url.hostname,
            port: url.port,
            path: '/uploadTestEndpoint',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        const speed = await testNetworkSpeed.checkUploadSpeed(options);
        console.log(speed);
        return speed;
    };

    static async calculateETA(arr,blob){
        const fileSize = blob.size;
        const arrSize = JSON.stringify(arr).length;
        const totalSize = fileSize + arrSize;
        let currentSpeed = await this.getNetworkUploadSpeed();
        if(currentSpeed.bps === "Infinity") {
            currentSpeed = await this.getNetworkUploadSpeed();
        }
        let etaCalc = 15;
        if(totalSize < 100000){
            etaCalc = (((arrSize + fileSize)/currentSpeed.bps)/8) + 2;
        }else{
            etaCalc = (((arrSize + fileSize)/currentSpeed.bps)/8) + 10;
        }
        if(isNaN(etaCalc)){
            etaCalc = 10;
        }
        return etaCalc;
    }

    static async getVideoSizes(){
        return {
            width: isIOS ? 320 : { ideal: 320 },
            height: isIOS ? 240 : { ideal: 240 }
        };
    }

    static async authorize(context) {
        let token = await localStorage.getItem('token');
        if (token) {
            await REST.authWithToken().then((response) => {
                if (!response.success) {
                    context.props.history.push('/login');
                }
            }, (error) => {
                context.props.history.push('/login');
            });
        }
        else {
            context.props.history.push('/login');
        }
    }

    static filterApps(studentUser,appStates){
        let allowedApps = [];
        let filteredApps = [];
        let standardAppsLevel = {
            0:["picturenaming"],
            1:["wordsignsay","slash"],
            2:["maze"],
            3:["copyright","kidspeak","kidsign"],
            4:["wordmark"],
            5:[],
            6:[]
        };
        let expectedAppsLevel = {
            0:[],
            1:[],
            2:[],
            3:[],
            4:[],
            5:[],
            6:[]
        };
        let finishedAppsLevel = {
            0:[],
            1:[],
            2:[],
            3:[],
            4:[],
            5:[],
            6:[]
        };
        if(studentUser&&studentUser.student){
            allowedApps = studentUser.student.apps.split(",");
            if(appStates && appStates.bestScores){
                let bestScores = appStates.bestScores;
                let readingLevel = studentUser.student.screeningLevel;
                for(let i=0; i<7; i++){
                    for(let fa of standardAppsLevel[i]){
                        if(allowedApps.includes(fa)){
                            expectedAppsLevel[i].push(fa);
                        }
                    }
                }
                for(let app of allowedApps){
                    if(app === "picturenaming"){
                        if(bestScores.pnLevel > 3){
                            finishedAppsLevel[0].push(app);
                        }
                        if(readingLevel >= 0){
                            filteredApps.push(app);
                        }
                    }else if(app === "wordsignsay"){
                        if(bestScores.wssLevel > 1){
                            finishedAppsLevel[1].push(app);
                        }
                        if(readingLevel >= 1){
                            filteredApps.push(app);
                        }
                    }else if(app === "copyright"){
                        if(bestScores.crLevel > 6){
                            finishedAppsLevel[3].push(app);
                        }
                        if(readingLevel >= 3){
                            filteredApps.push(app);
                        }
                    }else if (app === "slash"){
                        if(bestScores.slashLevel > 8){
                            finishedAppsLevel[1].push(app);
                        }
                        if(readingLevel >= 1){
                            filteredApps.push(app);
                        }
                    }else if (app === "kidsign"){
                        if(bestScores.kssLevel > 12){
                            finishedAppsLevel[3].push(app);
                        }
                        if(readingLevel >= 3){
                            filteredApps.push(app);
                        }
                    }else if (app === "kidspeak"){
                        if(bestScores.ksLevel > 12 ){
                            finishedAppsLevel[3].push(app);
                        }
                        if(readingLevel >= 3){
                            filteredApps.push(app);
                        }
                    }else if (app === "maze"){
                        if(bestScores.mazeLevel > 12){
                            finishedAppsLevel[2].push(app);
                        }
                        if(readingLevel >= 2){
                            filteredApps.push(app);
                        }
                    }else if (app === "wordmark"){
                        if(readingLevel >= 4){
                            filteredApps.push(app);
                        }
                    }
                }
            }
        }

        for(let app of allowedApps){
            if(!filteredApps.includes(app)){
                filteredApps.push(app);
            }
            // if(app === "picturenaming"){
            //     if(!filteredApps.includes(app)){
            //         filteredApps.push(app);
            //     }
            // }else if(app === "wordsignsay"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[0].length === expectedAppsLevel[0].length ){
            //         filteredApps.push(app);
            //     }
            // }else if(app === "copyright"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
            //         filteredApps.push(app);
            //     }
            // }else if (app === "slash"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[0].length === expectedAppsLevel[0].length ){
            //         filteredApps.push(app);
            //     }
            // }else if (app === "kidsign"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
            //         filteredApps.push(app);
            //     }
            // }else if (app === "kidspeak"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[2].length === expectedAppsLevel[2].length ){
            //         filteredApps.push(app);
            //     }
            // }else if (app === "maze"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[1].length === expectedAppsLevel[1].length ){
            //         filteredApps.push(app);
            //     }
            // }else if (app === "wordmark"){
            //     if(!filteredApps.includes(app) && finishedAppsLevel[3].length === expectedAppsLevel[3].length ){
            //         filteredApps.push(app);
            //     }
            // }
        }

        let finishedApps = finishedAppsLevel[0].concat(finishedAppsLevel[1],finishedAppsLevel[2],finishedAppsLevel[3],finishedAppsLevel[4],finishedAppsLevel[5],finishedAppsLevel[6]);

        return {
            filteredApps:filteredApps,
            finishedApps:finishedApps,
            allowedApps:allowedApps
        };
    }

}



// WEBPACK FOOTER //
// ./src/Shared/Helpers.js